import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-electricity",
  templateUrl: "./electricity.component.html",
  styleUrls: ["./electricity.component.scss"],
})
export class ElectricityComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  labelPosition: any = "elc";
  showSlap: boolean=true;
  electricityForm: FormGroup;
  ApartmentForm: FormGroup;
  states: string[] = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];
  constructor(private fb: FormBuilder) {
    this.electricityForm = this.fb.group({
      state: ["", Validators.required],
      board: ["", Validators.required],
      district: ["", Validators.required],
      acountNo: ["", Validators.required],
      mobile: ["", Validators.required],
    });

    this.ApartmentForm = this.fb.group({
      city: ["", Validators.required],
      apartment: ["", Validators.required],
      acountNo: ["", Validators.required],
      mobile: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.selectype('elc');
  }

  selectype(event) {
    // console.log(event.value);
    if (event == "elc") {
      this.showSlap = true;
      console.log(this.showSlap , this.labelPosition)
    } else {
      this.showSlap = false;
      console.log(this.showSlap , this.labelPosition)
    }
  }
}
